<template>
  <div class="relative">
    <div @click="toggleNews" class="flex items-center cursor-pointer mr-5 help_box relative">
      <i class="fa fa-bullhorn mr-2 text-lg"
   :class="unreadCount > 0 ? 'text-yellow-400 animate-bounce' : 'text-white'"></i>
      <div class="text-white text-lg h-10 flex items-center border-r border-gray-500 pr-4"></div>
      <span v-if="unreadCount > 0" class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
        {{ unreadCount }}
      </span>
    </div>

    <div v-if="isOpen" class="absolute top-12 right-0 w-96 bg-white shadow-2xl rounded-lg z-50 overflow-hidden border border-gray-400">
      <div class="bg-blue-nutri text-white p-4 py-2 font-bold flex justify-between items-center">
        <span>Announcements</span>
        <button @click="isOpen = false" class="text-white hover:text-gray-200 text-xl">&times;</button>
      </div>
      <div class="max-h-96 overflow-y-auto">
        <div v-if="loading" class="p-10 text-center text-gray-500">
           <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
        </div>
        <div v-else-if="newsItems.length === 0" class="p-10 text-center text-gray-400 italic">
          No announcements at this time.
        </div>
        <div v-else v-for="item in newsItems" :key="item.id" 
             @click="viewNews(item)"
             class="p-4  py-2 border-b hover:bg-gray-50 cursor-pointer transition-colors"
             :class="{'bg-blue-50': isUnread(item)}">
          <div class="flex justify-between items-start">
            <h3 class="font-bold text-gray-800" :class="{'text-blue-700': isUnread(item)}">{{ item.title }}</h3>
            <span v-if="isUnread(item)" class="bg-blue-600 text-white text-[10px] px-1.5 rounded uppercase font-bold">New</span>
          </div>
          <p class="text-xs text-gray-500 ">{{ item.show_publish_short }}</p>
          <!-- <div class="text-sm text-gray-600 line-clamp-2" v-html="excerpt(item.body)"></div> -->
        </div>
      </div>
    </div>

    <!-- News Detail Modal -->
    <div v-if="selectedNews" class="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div class="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div class="p-6 border-b flex justify-between items-center">
          <h2 class="text-2xl font-bold text-gray-800">{{ selectedNews.title }}</h2>
          <button @click="selectedNews = null" class="text-gray-500 hover:text-gray-800 text-3xl">&times;</button>
        </div>
        <div class="p-6 overflow-y-auto flex-1 quill-content">
          <p class="text-sm text-gray-500 mb-4">{{ selectedNews.show_publish_short }}</p>
          <div class="proses max-w-none ql-editor" v-html="selectedNews.body"></div>
        </div>
        <div class="p-4 border-t text-right">
          <button @click="selectedNews = null" class="button-color text-white px-6 py-2 rounded font-bold hover:bg-blue-700">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isOpen: false,
      newsItems: [],
      loading: false,
      selectedNews: null,
      unreadCount: 0
    }
  },
  mounted() {
    this.fetchNews();
    setTimeout(() => {
      if(this.unreadCount > 0){
        this.openUnreadPopup();
      }
    }, 5000);
  },
  methods: {
    fetchNews() {
      axios.post(this.route('announcements.latest')).then(res => {
        this.newsItems = res.data;
        this.calculateUnread();
      });
    },
    openUnreadPopup() {
      const cookieExists = document.cookie.split(';').some(item => item.trim().startsWith('news_popup_shown='));
      if (!cookieExists) {
        const firstUnread = this.newsItems.find(item => this.isUnread(item));
        if (firstUnread) {
          this.viewNews(firstUnread);
          document.cookie = "news_popup_shown=true; path=/; max-age=86400";
        }
      }
    },
    calculateUnread() {
      this.unreadCount = this.newsItems.filter(item => this.isUnread(item)).length;
    },
    isUnread(item) {
      return item.read_by_users.length === 0;
    },
    toggleNews() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.fetchNews();
      }
    },
    viewNews(item) {
      this.selectedNews = item;
      this.isOpen = false;
      
      if (this.isUnread(item)) {
        axios.post(this.route('announcements.mark-read'), { news_id: item.id }).then(() => {
          this.fetchNews();
        });
      }
    },
    excerpt(html) {
      const text = html.replace(/<[^>]*>?/gm, '');
      return text.length > 100 ? text.substring(0, 100) + '...' : text;
    }
  }
}
</script>

<style>
.quill-content a {
  color: #0092d0 ;
}
</style>

<style scoped>

.prose :deep(iframe) {
    width: 100%;
    aspect-ratio: 16/9;
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
</style>
